// extracted by mini-css-extract-plugin
module.exports =  {"branding-level-wrapper":"_93444fe79c--branding-level-wrapper--lpY8C","platinum":"_93444fe79c--platinum--j3tPs"};